/**
 * Camada fina de config — concentra acesso a env vars.
 *
 * Regra: nenhuma linha do app le `import.meta.env` fora daqui.
 * Se precisar de uma nova env, adicione neste arquivo com default seguro.
 */

interface AppConfig {
  readonly apiBaseUrl: string;
  readonly tokenStorageKey: string;
  readonly refreshTokenStorageKey: string;
}

function readApiBaseUrl(): string {
  const raw = import.meta.env['VITE_API_URL'];
  if (typeof raw === 'string' && raw.length > 0) {
    return raw.replace(/\/+$/, '');
  }
  // Default de dev — pressupoe backend real rodando em :3001.
  // O mock server (dev-server.ts) roda em :3000 — mas F2 consume a API real.
  return 'http://localhost:3001';
}

export const config: AppConfig = {
  apiBaseUrl: readApiBaseUrl(),
  tokenStorageKey: 'mktvibe.access_token',
  refreshTokenStorageKey: 'mktvibe.refresh_token',
};
